import Head from 'next/head'
import { FC } from 'react'

interface C1TitleProps {
    title: string;
    noSuffix?: boolean;
}

export const C1Title: FC<C1TitleProps> = ({ title, noSuffix }) => {
    return <Head>
        <title>{`${title}${noSuffix ? '' : ' - ConductorOne'}`}</title>
    </Head>
}
